import $ from "jquery";

if (document.querySelector(".stepper2-wrapper-slick")) {
  let currIndex = 0;
  const indicators = document.getElementsByClassName("screen-indicator");
  const progressElm = document.getElementsByClassName("progress")[0];
  const prevBtn = document.getElementById("prev-btn");
  const nextBtn = document.getElementById("next-btn");

  $('.slider-nav2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // variableWidth: true,
    // focusOnSelect: true
  });

  $('div[data-slide]').click(function (e) {
    e.preventDefault();
    const slideno = $(this).data('slide');
    const realSlideNo = slideno - 1;

    $('.slider-nav2').slick('slickGoTo', realSlideNo);
    progressElm.style.width = `${(realSlideNo / (indicators.length - 1)) * 100}%`;

    for (let i = 0; i < realSlideNo; i++) {
      indicators[i].classList.add("completed");
    }

    for (let i = realSlideNo; i < indicators.length; i++) {
      indicators[i].classList.remove("completed");
    }

    indicators[realSlideNo].classList.add("completed");
  });

  disableControls();

  $("#prev-btn").click(function () {
    indicators[currIndex].style.transitionDelay = "0s";
    indicators[currIndex].classList.remove("completed");
    currIndex--;
    progressElm.style.width = `${(currIndex / (indicators.length - 1)) * 100}%`;
    $('.slider-nav2').slick('slickGoTo', currIndex);
    $(".active").removeClass("active");
    indicators[currIndex].classList.add("active");
    disableControls();
  });

  $("#next-btn").click(function () {
    currIndex++;
    $('.slider-nav2').slick('slickGoTo', currIndex);
    indicators[currIndex].style.transitionDelay = "0.6s";
    indicators[currIndex].classList.add("completed");
    progressElm.style.width = `${(currIndex / (indicators.length - 1)) * 100}%`;
    $(".active").removeClass("active");
    indicators[currIndex].classList.add("active");
    disableControls();
  });

  function disableControls() {
    prevBtn.disabled = currIndex <= 0;
    nextBtn.disabled = currIndex >= indicators.length - 1;
  }
}
